export const treeIntro = {
    sub: "treeIntro.sub",
    heading: "treeIntro.heading",
    description: "treeIntro.description",
    points: [
        "treeIntro.points.0",
        "treeIntro.points.1",
        "treeIntro.points.2",
        "treeIntro.points.3",
        "treeIntro.points.4"
    ],
};

export const treebenefits = [
    {
        id: 1,
        title: "treebenefits.item1.title",
        description: "treebenefits.item1.description",
    },
    {
        id: 2,
        title: "treebenefits.item2.title",
        description: "treebenefits.item2.description",
    },
    {
        id: 3,
        title: "treebenefits.item3.title",
        description: "treebenefits.item3.description",
    },
    {
        id: 4,
        title: "treebenefits.item4.title",
        description: "treebenefits.item4.description",
    },
    {
        id: 5,
        title: "treebenefits.item5.title",
        description: "treebenefits.item5.description",
    },
    {
        id: 6,
        title: "treebenefits.item6.title",
        description: "treebenefits.item6.description",
    },
    {
        id: 7,
        title: "treebenefits.item7.title",
        description: "treebenefits.item7.description",
    },
    {
        id: 8,
        title: "treebenefits.item8.title",
        description: "treebenefits.item8.description",
    },
];

export const treesampleTasks = [
    "treesampleTasks.0",
    "treesampleTasks.1",
    "treesampleTasks.2",
    "treesampleTasks.3",
    "treesampleTasks.4",
    "treesampleTasks.5",
    "treesampleTasks.6",
];

export const manifestTree = [
    "manifestTree.0",
    "manifestTree.1",
    "manifestTree.2",
    "manifestTree.3",
    "manifestTree.4",
    "manifestTree.5",
    "manifestTree.6",
    "manifestTree.7"
];